import * as types from 'store/modules/hrms27u/mutation-types'
import hrms27u from 'api/hrms27u'
import swal from 'sweetalert'
import hrms27uLabels from 'assets/labels/hrms27u'
import { hrms27uColumns } from 'assets/columns/hrms27u'
import configLabel from 'src/../config/label'
import { sendApprove } from 'components/hrms27u/sendApproveHrms27u.js'

export default {
  state: {
    indexDisp: true,
    labels: hrms27uLabels,
    columns: hrms27uColumns(),
    index: {
      total: 0,
      rows: []
    },
    indexSelected: [],
    indexInlineData: [],
    popupApplinf: {},
    popupRequest: {}
  },
  getters: {
    [types.GET_HRMS27U_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRMS27U_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRMS27U_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRMS27U_INDEX] (state) {
      return state.index
    },
    [types.GET_HRMS27U_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRMS27U_INDEX_INLINE_DATA] (state) {
      return state.indexInlineData
    }
  },
  mutations: {
    [types.SET_HRMS27U_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRMS27U_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
      }
    },
    [types.SET_HRMS27U_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRMS27U_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRMS27U_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRMS27U_INDEX_INLINE_DATA] (state, indexInlineData) {
      state.indexInlineData = indexInlineData
    }
  },
  actions: {
    [types.TOGGLE_HRMS27U_PAGE] ({ commit }, page) {
      let indexDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
      }
      commit(types.SET_HRMS27U_INDEX_DISP, indexDisp)
    },
    [types.RECEIVED_HRMS27U_COLUMNS_LABELS] ({ commit }) {
      hrms27u.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS27U_COLUMNS, data.labels)
          commit(types.SET_HRMS27U_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS27U_INDEX] ({ commit }, searchParams) {
      hrms27u.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS27U_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
          let objData = {
            total: 0,
            rows: []
          }
          commit(types.SET_HRMS27U_INDEX, objData)
        })
    },
    [types.POST_HRMS27U_SEND_APPROVE] ({ commit, dispatch }, { searchIndex, dataRows, codappr, dteappr }) {
      sendApprove({
        params: {
          searchIndex: searchIndex,
          dataRows: dataRows,
          codappr: codappr,
          dteappr: dteappr
        },
        sendApprove: hrms27u.postSendApprove,
        dispatch: dispatch,
        dispatchType: types.RECEIVED_HRMS27U_INDEX
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hrms27u/index.js